import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const MiceRoutes = [
    {
        "url": `/settings/${hmapPathParamRegex}?activeTab&subTab`,
        "name": "appLayout.harriSH.access-portal.settings.main",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig,
            brandId: {
                dynamic: true
            },
        },
        "component": "hmapSettingsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["mice-v2"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/mice/mice.downgrade.module");
                }
            }
        ]
    },
    {
        "url": "/settings",
        "enableUTM": true,
        "name": "appLayout.harriSH.settings",
        "type": "frontend",
        "templateUrl": "../modules/settings/views/settings.html",
        "controller": 'SettingsController',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["mice-v2"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/mice/mice.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=mice.routes.js.map